import { SugarIcon } from '../../sugar-icon';

export const FilterIcon = props => {
  return <SugarIcon icon={'filter'} {...props} />;
};
